import { useGetClinicianWaitTime } from "@/api/generated";

const WAIT_TIME_THRESHOLD_MINUTES = 15;

export const useWaitTimeBanner = (): {
  showWaitTimeBanner: boolean;
  waitTimeCopy: string;
} => {
  const { data: waitTime, isLoading } = useGetClinicianWaitTime();
  const waitTimeMinutes = waitTime?.estimated_wait_minutes ?? 0;
  return {
    showWaitTimeBanner:
      !isLoading && waitTimeMinutes > WAIT_TIME_THRESHOLD_MINUTES,
    waitTimeCopy: `~${waitTimeMinutes} min wait time`,
  };
};
